<template>
<header class="sf-public-nav"><div class="sf-public-nav-inner">
  <a class="sf-public-logo" href="/" aria-label="StoryFaith home"><img src="/static/communities/header-logo.png" alt="StoryFaith"></a>
  <TopSearch />
  <nav aria-label="Main navigation">
    <a href="/discover/">Find a Church</a>
    <a href="/?section=app#explore-app">Explore the App</a>
    <details class="sf-public-menu"><summary>For Churches</summary><div>
      <a href="/for-churches/">For Church Leaders<span>Discover what StoryFaith can offer your ministry.</span></a>
      <a href="/create">Add Your Community<span>Begin your community page.</span></a>
      <a href="/interest/?intent=church&amp;source=leaders">Join the Interest List<span>Stay in touch about partnering with us.</span></a>
    </div></details>
    <a href="/about/">About</a>
    <a v-if="username" href="/#/">Your StoryFaith</a><a v-else :href="loginUrl">Log in</a>
  </nav>
</div></header>
</template>
<script>
import TopSearch from './TopSearch.vue'
export default { name: 'PublicHeader', components: {TopSearch}, props: { username: {type: String, default: ''}, loginUrl: {type: String, default: '/accounts/login/'} } }
</script>
